import { sendSocketMessage, socketMessageStream } from "../utils/socketStream";
import { filter, map } from "rxjs/operators";
import chat from "../store/modules/chat";
import site from "../store/modules/site";
import log2 from "../utils/log2";
import { publishMessage } from "../utils/systemPubSub";
import { PHONE_UTILS } from "../utils/phone";

const store = require("@/store").default;
const conversations = {};
export const getVideoCall = (number) => conversations[number];
const log = log2("phonesdk");
export const PHONE = (window.PHONE = (config) => {
    const socketMessagePrefix = "visitor ";
    const PHONE = () => {};
    const autocam = config.autocam === true;
    const sessionid = config.visitorId || chat.state.visitorId;
    const myNumber = sessionid;
    config.number = myNumber;
    let mediaconf = config.media || { audio: true, video: true };
    let isChrome = true;
    const screenSharingMediaConf = isChrome
        ? {
              video: {
                  mandatory: {
                      chromeMediaSource: "screen",
                      maxWidth: screen.width,
                      maxHeight: screen.height,
                      minFrameRate: 1,
                      maxFrameRate: 5,
                  },
                  optional: [],
              },
          }
        : {
              video: {
                  mediaSource: "screen",
              },
          };
    let camStarted = false;
    let myvideo = document.createElement("video");
    let screenVideo = document.createElement("video");
    let snapper = () => " ";
    let mystream = null;
    let myScreenStream = null;
    let myconnection = false;

    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    // RTC Peer Connection Session (one per call)
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    const PeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection;

    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    // ICE (many route options per call)
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    const IceCandidate = window.RTCIceCandidate || window.mozRTCIceCandidate;

    navigator.getUserMedia =
        navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    // Media Session Description (offer and answer per call)
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    const SessionDescription =
        window.RTCSessionDescription || window.mozRTCSessionDescription || window.webkitRTCSessionDescription;

    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    // STUN Server List Configuration (public STUN list)
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    const rtcconfig = {
        iceServers: [
            {
                urls: navigator.mozGetUserMedia
                    ? "stun:stun.services.mozilla.com"
                    : navigator.webkitGetUserMedia
                    ? "stun:stun.l.google.com:19302"
                    : "stun:23.21.150.121",
            },
            //{urls: "stun:stun.l.google.com:19302"},
            { urls: "stun:stun1.l.google.com:19302" },
            { urls: "stun:stun2.l.google.com:19302" },
            { urls: "stun:stun3.l.google.com:19302" },
        ],
        iceTransportPolicy: "all",
        iceCandidatePoolSize: "0",
    };

    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    // Custom STUN Options
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    function add_servers(servers) {
        if (servers.constructor === Array) [].unshift.apply(rtcconfig.iceServers, servers);
        else rtcconfig.iceServers.unshift(servers);

        log("ice servers", rtcconfig.iceServers);
    }

    if ("servers" in config) add_servers(config.servers);

    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    // PHONE Events
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    const noop = () => {};
    let cameracb = noop;
    let screencb = noop;
    let messagecb = noop;
    let readycb = noop;
    let unablecb = noop;
    let debugcb = log;
    let connectcb = noop;
    let disconnectcb = noop;
    let reconnectcb = noop;
    let callstatuscb = noop;
    let receivercb = noop;

    PHONE.message = (cb) => (messagecb = cb);
    PHONE.camera = (cb) => (cameracb = cb);
    PHONE.screen = (cb) => (screencb = cb);
    PHONE.ready = (cb) => (readycb = cb);
    PHONE.unable = (cb) => (unablecb = cb);
    PHONE.callstatus = (cb) => (callstatuscb = cb);
    PHONE.debug = (cb) => (debugcb = cb);
    PHONE.connect = (cb) => (connectcb = cb);
    PHONE.disconnect = (cb) => (disconnectcb = cb);
    PHONE.reconnect = (cb) => (reconnectcb = cb);
    PHONE.receive = (cb) => (receivercb = cb);

    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    // Add/Get Conversation - Creates a new PC or Returns Existing PC
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    function get_conversation(number) {
        var talk =
            conversations[number] ||
            (function (number) {
                var talk = {
                    number: number,
                    status: "",
                    image: document.createElement("img"),
                    started: +new Date(),
                    imgset: false,
                    imgsent: 0,
                    pc: new PeerConnection(rtcconfig),
                    closed: false,
                    usermsg: function () {},
                    thumb: null,
                    connect: function () {},
                    end: function () {},
                };

                // Setup Event Methods
                talk.pc.ontrack =
                    config.ontrack ||
                    function (event) {
                        onaddstream(number, event);
                    };
                talk.pc.onicecandidate = function (event) {
                    onicecandidate(number, event);
                };
                talk.pc.onnegotiationneeded = (event) => {
                    log("onnegotiationneeded called", number);
                    log("createOffer running onnegotiationneeded", number);
                    talk.pc
                        .createOffer()
                        .then((offer) => {
                            log("createOffer success onnegotiationneeded", number);
                            talk.pc
                                .setLocalDescription(offer)
                                .then(() => {
                                    log("setLocalDescription success onnegotiationneeded", number);
                                    transmit(number, offer);
                                })
                                .catch((e) => {
                                    log.error("onnegotiationneeded setLocalDescription error", e);
                                });
                        })
                        .catch((e) => {
                            log.error("onnegotiationneeded createOffer error", e);
                        });
                };
                // Disconnected?
                talk.pc.oniceconnectionstatechange = function () {
                    log("oniceconnectionstatechange", talk.pc.iceConnectionState);
                    if (talk.pc.iceConnectionState == "disconnected") {
                        log.warn("iceConnectionState disconnected hangup calling", number);
                        // talk.hangup(true)
                        // publishMessage('vc_ended', {signal:true  })
                    }
                };
                talk.pc.number = number;

                // Disconnect and Hangup
                talk.hangup = function (signal) {
                    log("hangup", talk);
                    stopcamera();
                    talk.closed = true;
                    talk.imgset = false;
                    clearInterval(talk.snapi);

                    if (signal !== false) transmit(number, { hangup: true });

                    talk.end(talk);
                    // talk.pc.getLocalStreams().map(x=>x.getTracks().map(x=>x.stop()) )
                    talk.pc.close();
                    close_conversation(number);
                };

                // Stop Audio/Video Stream
                talk.stop = function () {
                    log("stop", talk);
                    if (mystream) mystream.stop();
                    return mystream;
                };

                // Sending Messages
                talk.send = function (message) {
                    transmit(number, { usermsg: message });
                };

                // Sending Stanpshots
                talk.snap = function () {
                    var pic = snapper();
                    if (talk.closed) clearInterval(talk.snapi);
                    transmit(number, { thumbnail: pic });
                    var img = document.createElement("img");
                    img.src = pic;
                    return { data: pic, image: img };
                };
                talk.snapi = setInterval(function () {
                    return;
                    if (talk.imgsent++ > 1) return clearInterval(talk.snapi);
                    talk.snap();
                }, 5000);
                talk.snap();

                // Nice Accessor to Update Disconnect & Establis CBs
                talk.thumbnail = function (cb) {
                    talk.thumb = cb;
                    return talk;
                };
                talk.ended = function (cb) {
                    log("ended");
                    talk.end = cb;
                    return talk;
                };
                talk.connected = function (cb) {
                    log("connected");
                    talk.connect = cb;
                    return talk;
                };
                talk.message = function (cb) {
                    talk.usermsg = cb;
                    return talk;
                };

                // Add Local Media Streams Audio Video Mic Camera
                if (mystream) {
                    log("tracks adding started");
                    mystream.getTracks().forEach((track) => {
                        const sender = talk.pc.addTrack(track, mystream);
                        setTimeout(() => {
                            if (talk.pc.signalingState !== "closed" && !config["isMobile"]) {
                                try {
                                    talk.pc.removeTrack(sender);
                                } catch (e) {
                                    console.error("remove track error", e);
                                }
                                talk.pc.addTrack(track, mystream);
                            }
                        }, 2000);
                        log("addTrack->", {
                            streamId: mystream.id,
                            track,
                            sender,
                        });
                    });
                }

                // Notify of Call Status
                update_conversation(talk, "connecting");

                // Return Brand New Talk Reference
                conversations[number] = talk;
                return talk;
            })(number);

        // Return Existing or New Reference to Caller
        return talk;
    }

    PHONE.conversations = conversations;
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    // Remove Conversation
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    function close_conversation(number) {
        log("close_conversation", number);
        conversations[number] = null;
        delete conversations[number];
    }

    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    // Notify of Call Status Events
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    function update_conversation(talk, status) {
        log("update_conversation", talk, status);
        talk.status = status;
        callstatuscb(talk);
        return talk;
    }

    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    // DOM Bind
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    PHONE.bind = (type, el, fun) => {
        type.split(",").forEach((etype) => {
            const rapfun = (e) => {
                if (!e) e = window.event;
                if (!fun(e)) {
                    e.cancelBubble = true;
                    e.preventDefault && e.preventDefault();
                    e.stopPropagation && e.stopPropagation();
                }
            };

            if (el.addEventListener) el.addEventListener(etype, rapfun, false);
            else if (el.attachEvent) el.attachEvent("on" + etype, rapfun);
            else el["on" + etype] = rapfun;
        });
    };

    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    // DOM UNBind
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    PHONE.unbind = (type, el, fun) => {
        if (el.removeEventListener) el.removeEventListener(type, false);
        else if (el.detachEvent) el.detachEvent("on" + type, false);
        else el["on" + type] = null;
    };

    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    // Get Number
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    PHONE.number = () => {
        return myNumber;
    };

    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    // Get Call History
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    PHONE.history = (settings) => {
        console.warn("TODO not implemented");
        // pubnub.history({
        //     channel  : settings[number],
        //     callback : call_history => {
        //         settings['history'](call_history[0]);
        //     }
        // })
    };

    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    // Make Call - Create new PeerConnection
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    PHONE.dial = async function (number, servers, source) {
        log("PHONE.dial", number, source);
        stopcamera();
        await startcamera();
        if (!!servers) add_servers(servers);
        var talk = get_conversation(number);
        var pc = talk.pc;

        // Prevent Repeat Calls
        if (talk.dialed) return false;
        talk.dialed = true;
        store.dispatch("app/setVideoCall", number);

        return talk;
    };

    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    // Send Image Snap - Send Image Snap to All Calls or a Specific Call
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    PHONE.snap = function (message, number) {
        if (number) return get_conversation(number).snap(message);
        let pic = {};
        for (let number in conversations) pic = conversations[number].snap();
        return pic;
    };

    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    // Send Message - Send Message to All Calls or a Specific Call
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    PHONE.send = (message, number) => {
        if (number) return get_conversation(number).send(message);
        for (let number in conversations) conversations[number].send(message);
    };

    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    // End Call - Close All Calls or a Specific Call
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    PHONE.hangup = (number) => {
        log("hangup", number);
        if (number) return get_conversation(number).hangup();
        for (let number in conversations) conversations[number].hangup();
    };

    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    // Auto-hangup on Leave
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    PHONE.bind("unload,beforeunload", window, () => {
        log("unload called", PHONE.goodbye);
        if (PHONE.goodbye) return true;
        PHONE.goodbye = true;

        for (let number in conversations) {
            let talk = conversations[number];
            let mynumber = config.number;
            let packet = { hangup: true };
            let message = { packet: packet, id: sessionid, number: mynumber };
            sendSocketMessage(socketMessagePrefix + "webrtc", message);
            talk.hangup();
        }

        return true;
    });

    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    // Grab Local Video Snapshot
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    function snapshots_setup(stream) {
        log("snapshots_setup called");
        let video = myvideo || document.createElement("video");
        let canvas = document.createElement("canvas");
        let context = canvas.getContext("2d");
        let snap = { width: 240, height: 180 };

        // Video Settings
        video.width = snap.width;
        video.height = snap.height;
        video.srcObject = stream;
        video.volume = 0.0;

        // Start Video Stream
        try {
            video.play();
        } catch (e) {
            debugcb(["video.play(FAIL)", e]);
        }

        return video;
        // // Canvas Settings
        // canvas.width = snap.width
        // canvas.height = snap.height
        //
        // // Capture Local Pic
        // snapper = () => {
        //     try {
        //         context.drawImage(video, 0, 0, snap.width, snap.height)
        //     } catch (e) { debugcb(['context.drawImage(FAIL)', e]) }
        //     return canvas.toDataURL('image/jpeg', 0.30)
        // }
    }

    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    // Visually Display New Stream
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    function onaddstream(number, obj) {
        log("onaddstream", { number, obj });
        changeStream(number, obj.streams[0]);
        publishMessage("videocall-success", true);
    }

    /**
     * video connect fırlatır
     * @param number
     * @param stream
     */
    function changeStream(number, stream) {
        let vid = document.createElement("video");
        let talk = get_conversation(number);
        if (talk.video) {
            talk.video.srcObject = null;
        }
        vid.setAttribute("autoplay", "autoplay");
        vid.setAttribute("playsinline", "playsinline");
        vid.srcObject = null;
        log.info("changeStream", stream);
        vid.srcObject = stream;
        talk.video = vid;
        talk.connect(talk);
    }

    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    // On ICE Route Candidate Discovery
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    function onicecandidate(number, event) {
        log("onicecandidate", { number, event });
        if (!event.candidate) return;
        transmit(number, event.candidate);
    }

    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    // Listen For New Incoming Calls
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    function dailer_subscribe() {
        // Extend edilmiş implementasyon
        onready(true);
        socketMessageStream
            .pipe(
                filter((x) => x.cmd === "webrtc"),
                map((x) => x.data)
            )
            .subscribe((data) => {
                receive(data);
            });
    }

    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    // When Ready to Receive Calls
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    function onready(subscribed) {
        log("onready called");
        if (subscribed) myconnection = true;
        if (myconnection && autocam) readycb();
        if (!(mystream && myconnection)) return;

        connectcb();
        if (!autocam) readycb();
    }

    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    // Prepare Local Media Camera and Mic
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    let userMediaRequests = [];

    function startcamera() {
        log("startcamera", { camStarted });
        if (camStarted) return;

        camStarted = true;
        log("startcamera called");
        return navigator.mediaDevices
            .getUserMedia(mediaconf)
            .then((stream) => {
                log("getUserMedia resolved", stream);
                if (!stream) return unablecb(stream);
                userMediaRequests.push(stream);
                mystream = stream;
                cameracb(snapshots_setup(stream));
                onready();
                camStarted = true;
                store.dispatch("webrtc/setVideoEnabled", true);

                Object.keys(PHONE.conversations).forEach((id) => {
                    const talk = get_conversation(id);
                    try {
                        talk.pc.getLocalStreams().forEach((x) =>
                            x.getVideoTracks().forEach((track) => {
                                track.enabled = true;
                            })
                        );
                    } catch (e) {
                        console.error("toggleTrack error", e);
                    }
                });
            })
            .catch((info) => {
                debugcb(["navigator.mediaDevices.getUserMedia(FAIL)", info]);
                camStarted = false;
                return unablecb(info);
            });
    }

    function startScreenSharing() {
        log("startScreenSharing called", screenSharingMediaConf);
        return navigator.mediaDevices
            .getDisplayMedia({ video: true })
            .then((stream) => {
                log("startScreenSharing  getUserMedia resolved", stream);
                if (!stream) return;
                myScreenStream = stream;
                let video = screenVideo;

                video.srcObject = stream;
                video.volume = 0.0;

                // Start Video Stream
                try {
                    video.play();
                } catch (e) {
                    debugcb(["video.play(FAIL)", e]);
                }

                screencb(myvideo);
                let videoScreenRTCSender;
                Object.keys(PHONE.conversations).forEach((id) => {
                    const talk = get_conversation(id);
                    try {
                        stream.getTracks().forEach((track) => {
                            videoScreenRTCSender = talk.pc.addTrack(track, stream);
                            log("addScreenTrack->", {
                                streamId: mystream.id,
                                track,
                                videoScreenRTCSender,
                            });
                        });
                    } catch (e) {
                        console.error("toggleTrack error", e);
                    }
                });
                stream.onremovetrack = () => {
                    log("screen onremovetrack called");
                };
                stream.getVideoTracks().forEach((t) => {
                    t.onended = () => {
                        log("screen track onended called");
                        publishMessage("screen_share_ended", {});
                        Object.keys(PHONE.conversations).forEach((number) => {
                            const talk = get_conversation(number);
                            try {
                                if (videoScreenRTCSender) talk.pc.removeTrack(videoScreenRTCSender);
                                log("removeScreenTrack->", {
                                    streamId: stream.id,
                                    t,
                                });
                                cameracb(snapshots_setup(mystream));
                            } catch (e) {
                                console.error("toggleTrack error", e);
                            }
                        });
                    };
                });
                return video;
            })
            .catch((err) => {
                log.error("startScreenSharing error", err);
                debugcb(["navigator.mediaDevices.getUserMedia(FAIL)", err]);
                return false;
            });
    }

    function stopScreenSharing() {
        log("stopScreenSharing called", screenSharingMediaConf);
        if (!myScreenStream) return;
        for (let track of myScreenStream.getTracks()) track.stop();
    }

    async function changeCamera(isFront) {
        let newFacingMode = isFront ? "user" : "environment";
        const mediaConf = {
            video: {
                facingMode: {
                    exact: newFacingMode,
                },
            },
        };
        log("changeCamera called", { isFront, mediaConf });
        toggleVideo(false);
        userMediaRequests.forEach((stream) => closeStream(stream));
        userMediaRequests = [];
        closeStream(mystream);
        return navigator.mediaDevices
            .getUserMedia(mediaConf)
            .then((stream) => {
                log("getUserMedia resolved", stream);
                if (!stream) return unablecb(stream);

                userMediaRequests.push(stream);
                mystream = stream;
                cameracb(snapshots_setup(stream));
                onready();
                camStarted = true;
                let videoTrack = stream.getVideoTracks()[0];

                //window.alert(`${videoTrack.kind}`);
                Object.keys(PHONE.conversations).forEach((id) => {
                    const talk = get_conversation(id);
                    try {
                        const senders = [];
                        talk.pc.getSenders().forEach((s) => {
                            log("changeCamera trc ", { rtc: s, video: videoTrack });
                            if (s.track && s.track.kind === videoTrack.kind) {
                                senders.push(s);
                            }
                        });
                        senders.forEach((sender) => {
                            log("changeCamera senders", sender);
                            sender
                                .replaceTrack(videoTrack)
                                .then((x) => {
                                    log("changeCamera replace track successfull");
                                })
                                .catch((x) => {
                                    console.error("changeCamera error");
                                });
                        });
                        // sender.replaceTrack(videoTrack);
                    } catch (e) {
                        console.error("changeCamera error", e);
                        log.error(e);
                    }
                });
            })
            .catch((info) => {
                debugcb(["navigator.mediaDevices.getUserMedia(FAIL)", info]);
                camStarted = false;
                return unablecb(info);
            });
    }

    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    // Stop Camera/Mic
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    function stopcamera() {
        log("stopcamera called", mystream);
        userMediaRequests.forEach((stream) => closeStream(stream));
        userMediaRequests = [];
        closeStream(mystream);
        camStarted = false;
        store.dispatch("webrtc/setVideoEnabled", false);
        return true;
    }

    function closeStream(stream) {
        log("closeStream");
        if (!stream) return;
        for (let track of stream.getTracks()) track.stop();
        Object.keys(PHONE.conversations).forEach((id) => {
            const talk = get_conversation(id);
            try {
                talk.pc.getSenders().forEach((sender) => {
                    sender.enabled = false;
                });
            } catch (e) {
                console.error("toggleTrack error", e);
            }
        });
    }

    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    // Toggle Mic
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    function toggleAudio() {
        log("toggleAudio called");
        if (!mystream) return;
        let enabled = false;
        for (let track of mystream.getAudioTracks()) {
            track.enabled = !track.enabled;
            enabled = track.enabled;
            store.dispatch("webrtc/setMicEnabled", enabled);
        }
        Object.keys(PHONE.conversations).forEach((id) => {
            const talk = get_conversation(id);
            try {
                talk.pc.getLocalStreams().forEach((x) =>
                    x.getAudioTracks().forEach((track) => {
                        track.enabled = enabled;
                    })
                );
            } catch (e) {
                console.error("toggleTrack error", e);
            }
        });
    }

    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    // Toggle Camera
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    function toggleVideo(updateStore = true) {
        log("toggleVideo called");
        if (!mystream) return;
        let enabled = false;
        for (let track of mystream.getVideoTracks()) {
            track.enabled = !track.enabled;
            enabled = track.enabled;
            log("toggleVideo track", track);
            if (updateStore) store.dispatch("webrtc/setVideoEnabled", enabled);
        }
        Object.keys(PHONE.conversations).forEach((id) => {
            const talk = get_conversation(id);
            try {
                talk.pc.getLocalStreams().forEach((x) =>
                    x.getVideoTracks().forEach((track) => {
                        track.enabled = enabled;
                    })
                );
            } catch (e) {
                console.error("toggleTrack error", e);
            }
        });
    }

    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    // Initiate Dialing Socket
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    function startsubscribe() {
        log("startsubscribe called");
        onready();
        dailer_subscribe();
    }

    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    // Send SDP Call Offers/Answers and ICE Candidates to Peer
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    function transmit(phone, packet) {
        log("transmit called");
        if (!packet) return;
        let number = myNumber;
        let message = { packet: packet, id: sessionid, number: number };
        //debugcb(['transmit(PASS)', message]);
        sendSocketMessage(socketMessagePrefix + "webrtc", {
            message,
            me: number,
            to: phone,
            siteId: site.state.site._id,
        });
    }

    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    // SDP Offers & ICE Candidates Receivable Processing
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    function receive(message) {
        // log('receive called');
        // Debug Callback of Data to Watch
        //debugcb(['receive(PASS)', message]);
        const existsVC = conversations[message.number];
        if (message.packet.thumbnail && !existsVC) return;
        // Get Call Reference
        let talk = get_conversation(message.number);
        // log('receive', message, talk);
        // Ignore if Closed
        if (talk.closed) return;
        // if (message.packet.calling){
        //     const agentNumber = message.packet.calling
        //     talk.dial()
        // }

        // User Message
        if (message.packet.usermsg) {
            log("usermsg  received");
            messagecb(talk, message.packet.usermsg);
            return talk.usermsg(talk, message.packet.usermsg);
        }

        // Thumbnail Preview Image
        if (message.packet.thumbnail) {
            log("thumbnail  received");
            return create_thumbnail(message);
        }

        // If Hangup Request
        if (message.packet.hangup) {
            log("hangup  received");
            store.dispatch("app/setVideoCallMode", false);
            store.dispatch("app/setCalling", null);
            store.dispatch("app/setVideoCall", null);
            return talk.hangup(false);
        }

        // If Peer Calling Inbound (Incoming)
        if (message.packet.sdp && !talk.received) {
            log("sdp  received 1");
            talk.received = true;
            receivercb(talk);
        }

        // Update Peer Connection with SDP Offer or ICE Routes
        if (message.packet.sdp) {
            log("offer  received 1");
            add_sdp_offer(message);
        } else {
            log("ice  received 1");
            add_ice_route(message);
        }
    }

    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    // Create Remote Friend Thumbnail
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    function create_thumbnail(message) {
        log("create_thumbnail called");
        let talk = get_conversation(message.number);
        talk.image.src = message.packet.thumbnail;

        // Call only once
        if (!talk.thumb) return;
        if (!talk.imgset) talk.thumb(talk);
        talk.imgset = true;
    }

    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    // Add SDP Offer/Answers
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    async function add_sdp_offer(message) {
        log("add_sdp_offer", message);
        // Get Call Reference
        let talk = get_conversation(message.number);
        let pc = talk.pc;
        let type = message.packet.type == "offer" ? "offer" : "answer";

        // Deduplicate SDP Offerings/Answers
        // if (type in talk) return
        talk[type] = true;
        talk.dialed = true;

        // Notify of Call Status
        update_conversation(talk, "routing");

        pc.setRemoteDescription(
            new SessionDescription(message.packet),
            function () {
                log("setRemoteDescription success 2");
                // Set Connected Status
                update_conversation(talk, "connected");

                // Call Online and Ready
                if (pc.remoteDescription.type != "offer") return;

                // Create Answer to Call
                pc.createAnswer(
                    function (answer) {
                        log("createAnswer success");
                        pc.setLocalDescription(
                            answer,
                            () => {
                                log("setLocalDescription success 2");
                                transmit(message.number, answer);
                            },
                            (e) => {
                                log("setLocalDescription error 2", e);
                            }
                        );
                    },
                    (e) => {
                        log.error("createAnswer error 2", e);
                    }
                );
            },
            (e) => {
                log.error("setRemoteDescription error 2", e);
            }
        );
    }

    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=- =-=-=-=-=-=-=-=-=-=-=-=-=-=-
    // Add ICE Candidate Routes
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    function add_ice_route(message) {
        log("add_ice_route", message);
        // Leave if Non-good ICE Packet
        if (!message.packet) return;
        if (!message.packet.candidate) return;

        // Get Call Reference
        const talk = get_conversation(message.number);
        const pc = talk.pc;

        // Add ICE Candidate Routes
        function add_ice_route(message) {
            log("add_ice_route", message);
            // Leave if Non-good ICE Packet
            if (!message.packet) return;
            if (!message.packet.candidate) return;

            // Get Call Reference
            const talk = get_conversation(message.number);
            const pc = talk.pc;

            // Add ICE Candidate Routes
            pc.addIceCandidate(
                new IceCandidate(message.packet),
                () => {
                    log("add ice candidate success");
                },
                (e) => {
                    log.error("add ice candidate error", e);
                }
            );
        }
    }

    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    // Main - Setup Dialer Socket and Camera
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    PHONE.startcamera = startcamera;
    PHONE.camera.start = startcamera;
    PHONE.camera.stop = stopcamera;
    PHONE.camera.changeCamera = changeCamera;
    PHONE.camera.toggleAudio = toggleAudio;
    PHONE.camera.toggleVideo = toggleVideo;
    PHONE.camera.video = () => myvideo;
    PHONE.screen.start = startScreenSharing;
    PHONE.screen.stop = stopScreenSharing;
    PHONE.screen.video = () => screenVideo;
    PHONE.camera.ready = PHONE.camera;
    PHONE.configUpdate = (config) => {
        mediaconf = config.media;
    };
    // Start Camera Automatically
    if (autocam) startcamera();

    // Start Dailer Socket
    startsubscribe();

    // Return Phone API
    return PHONE;
});



// WEBPACK FOOTER //
// ./src/webrtc/phoneSDK.js